/**
 * Superficies de la SPA (contrato §0, AF §1.4). El header `X-Surface` viaja en TODO
 * request y es lo que la auditoría guarda (RN-ROL-10): decir cuál es no es cosmética.
 *
 * La SPA es una sola y cubre tres de las cinco superficies del AF: portal admin, portal
 * profesores y tablet kiosko. Las otras dos (app de socios y punto de acceso) son otros
 * clientes.
 */
import type { Surface as SharedSurface } from "@viva/shared";

export type Surface = Extract<SharedSurface, "admin_portal" | "teachers_portal" | "kiosk">;

export type Area = "admin" | "profes" | "kiosko";

export const DEFAULT_SURFACE: Surface = "admin_portal";

export const SURFACE_BY_AREA: Record<Area, Surface> = {
  admin: "admin_portal",
  profes: "teachers_portal",
  kiosko: "kiosk",
};

export const AREA_LABEL: Record<Area, string> = {
  admin: "Portal admin",
  profes: "Portal profesores",
  kiosko: "Tablet kiosko",
};

/**
 * El área que corresponde a una URL. Fuera de las tres áreas, se asume admin. `/tablet` es
 * la URL fija de la tablet de recepción (21-oct-2026): la misma área kiosko.
 */
export function areaFromPath(pathname: string): Area {
  if (pathname.startsWith("/profes")) return "profes";
  if (pathname.startsWith("/kiosko") || /^\/tablet(\/|$)/.test(pathname)) return "kiosko";
  return "admin";
}

/** Horas de inactividad de los portales — default del AF (`session.portalIdleHours`). */
export const PORTAL_IDLE_HOURS = 8;

/**
 * RN-ROL-16: los portales expiran a las 8 h de inactividad.
 *
 * La tablet kiosko, en cambio, **re-loguea al inicio de cada turno de caja** — y el turno
 * de caja lo define §8, que todavía no está construido. Hasta que exista, el kiosko usa
 * la misma ventana de inactividad y el corte por turno queda declarado como pendiente
 * (`web/README.md`, sección «supuestos»): no se inventa un corte que el sistema no puede
 * calcular todavía.
 */
export function idleMsForSurface(_surface: Surface): number {
  return PORTAL_IDLE_HOURS * 60 * 60_000;
}
